module.exports = __webpack_public_path__ + "static/media/product.ba653336.png";